<template lang='html'>
  <v-app :dark="dark" :light="light">
    <v-navigation-drawer app :value="false" v-if="3 === 4">
      NavBar
    </v-navigation-drawer>
    <v-toolbar app dense>
      <router-link class="v-toolbar__title handFont" to="/" v-ripple>
        <span class="name">SPORT</span><span class="grey--text">app</span>
      </router-link>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn flat to="/workout" color="amber" active-class="bold" v-if="activeWorkout">
          <i class="icon-accessibility" /> &nbsp;
          {{ activeWorkout.plan.name }}
        </v-btn>
        <v-btn flat to="/workouts" active-class="bold" v-else>Workouts</v-btn>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-toolbar-items v-if="hasHeaderActions">
        <slot name="HeaderActions">actions</slot>
      </v-toolbar-items>
      <v-menu  offset-y left min-width="200">
        <template v-slot:activator="{ on }">
          <v-btn  v-on="on" icon>
            <v-icon dark>menu</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-tile v-for="lnk in links" :key="lnk.icon" :to="lnk.path">
            <v-list-tile-avatar><i :class="'icon-' + lnk.icon"/></v-list-tile-avatar>
            <v-list-tile-title v-text="lnk.name"></v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="logout">
            <v-list-tile-avatar><i class="icon-exit"/></v-list-tile-avatar>
            <v-list-tile-title v-text="'Logout'"></v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <!-- <v-toolbar-side-icon class="hidden-md-and-up" /> -->
    </v-toolbar>
    <v-content>
      
      <div class="flexColumn fill-height" :class="{'amber--text': dark}">
        <div class='TopArea' v-if="hasTopArea">
          <slot name="top">Top-Area</slot>
        </div>
        <v-container :class="{middled: middled}" v-touch="touchStuff">
          <slot />
        </v-container>
        <div class='BottomArea' v-if="hasBottomArea">
          <slot name="bottom">Bottom-Area</slot>
        </div>
      </div>
      
    </v-content>
    <v-footer class="pa-3" height="auto" app v-if="hasFooter">
      <v-spacer></v-spacer>
      <slot name="footer">Footer</slot>
      <v-spacer></v-spacer>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppLayout',
  props: {
    middled:  { type: Boolean, default: false },
    swipe:    { type: Boolean, default: false }
  },
  data() {
    return {
      links: [
        { icon: 'accessibility', name: 'Workouts', path: '/workouts' },
        { icon: 'calendar', name: 'Calendar', path: '/calendar' },
        { icon: 'cogs', name: 'Settings', path: '/settings' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      currentUser:    'currentUser',
      activeWorkout:  'activeWorkout',
      messages:       'getMessages'
    }),
    hasTopArea() {
      return this.$slots.top && this.$slots.top !== '' && this.$slots.top !== null
    },
    hasBottomArea() {
      return this.$slots.bottom && this.$slots.bottom !== '' && this.$slots.bottom !== null
    },
    hasHeaderActions() {
      return this.$slots.HeaderActions && this.$slots.HeaderActions !== '' && this.$slots.HeaderActions !== null
    },
    hasFooter() {
      return this.$slots.footer && this.$slots.footer !== '' && this.$slots.footer !== null
    },
    light() {
      let that = true
      if (this.currentUser) {
        that = this.currentUser.app_style === 'light'
      }
      return that
    },
    dark() {
      let that = false
      if (this.currentUser) {
        that = this.currentUser.app_style === 'dark'
      }
      return that
    },
    touchStuff() {
      let touchStuff = {}
      if (this.swipe) {
        touchStuff = {
          left: () => this.swiped('Left'),
          right: () => this.swiped('Right')
        }
      }
      return touchStuff
    }
  },
  methods: {
    logout(){
      this.showCollapse = false
      this.$router.push('/login')
      localStorage.removeItem('store')
      this.$store.dispatch('logout').then(()=>{
        // this.toggleCollapse()
        // this.toggleDropdown()
        this.showCollapse = false
        this.showDropdown = false
        this.$router.push('/')
      })
    },
    swiped(direction) {
      this.$emit(`swipe${direction}`);
    }
  }
}
</script>

<style lang='scss' scoped>

.flexColumn {
  display: flex;
  flex-direction: column;
  align-content: space-between;
  align-items: stretch;
}
.TopArea {}
.BottomArea {
  padding: 10px;
  // background: #000;
  border-top: solid 1px #ccc;
}

.handFont {
  font-family: 'Shadows Into Light', cursive;
}

</style>